var map = {
	"./american_football.png": 445,
	"./badminton.png": 446,
	"./baseball.png": 447,
	"./basketball.png": 448,
	"./bowls.png": 449,
	"./boxing.png": 450,
	"./counter_strike.png": 451,
	"./cricket.png": 452,
	"./cycling.png": 453,
	"./darts.png": 454,
	"./dota_2.png": 455,
	"./e_cricket.png": 456,
	"./e_fighting.png": 457,
	"./fifa.png": 458,
	"./fifa_volta.png": 459,
	"./formula1.png": 460,
	"./golf.png": 461,
	"./handball.png": 462,
	"./ice_hokey.png": 463,
	"./motorcycle_racing.png": 464,
	"./nba2k19.png": 465,
	"./rugby.png": 466,
	"./snooker.png": 467,
	"./soccer.png": 468,
	"./tabletennis.png": 469,
	"./tennis.png": 470,
	"./volleyball.png": 471,
	"./waterpolo.png": 472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1204;